import React from 'react';
import { FaLaptopCode, FaRobot, FaMobileAlt, FaCloud, FaCogs, FaChartBar, FaShieldAlt, FaStore, FaSalesforce } from 'react-icons/fa';
import { motion } from 'framer-motion';

const ServiceCategories = ({ theme = 'light' }) => {
  // Check if the theme is light or dark for styling
  const isLight = theme === 'light';

  const categories = [
    {
      name: "Software & Web Development",
      icon: <FaLaptopCode className={`${isLight ? 'text-blue-600' : 'text-blue-400'} w-10 h-10`} />,
      description: "Custom websites, full-stack applications & UI/UX design"
    },
    {
      name: "AI & Machine Learning",
      icon: <FaRobot className={`${isLight ? 'text-blue-600' : 'text-blue-400'} w-10 h-10`} />,
      description: "AI chatbots, machine learning models & data science"
    },
    {
      name: "Mobile App Development",
      icon: <FaMobileAlt className={`${isLight ? 'text-blue-600' : 'text-blue-400'} w-10 h-10`} />,
      description: "iOS, Android & cross-platform mobile applications"
    },
    {
      name: "DevOps & Cloud Solutions",
      icon: <FaCloud className={`${isLight ? 'text-blue-600' : 'text-blue-400'} w-10 h-10`} />,
      description: "CI/CD, IaC & cloud architecture optimization"
    },
    {
      name: "AI Automation & AI Agents",
      icon: <FaCogs className={`${isLight ? 'text-blue-600' : 'text-blue-400'} w-10 h-10`} />,
      description: "Workflow automation & intelligent virtual assistants"
    },
    {
      name: "Salesforce Development",
      icon: <FaSalesforce className={`${isLight ? 'text-blue-600' : 'text-blue-400'} w-10 h-10`} />,
      description: "Custom Salesforce solutions & CRM optimization"
    },
    {
      name: "E-Commerce Solutions",
      icon: <FaStore className={`${isLight ? 'text-blue-600' : 'text-blue-400'} w-10 h-10`} />,
      description: "Shopify, WooCommerce & payment integrations"
    },
    {
      name: "Data Analytics & BI",
      icon: <FaChartBar className={`${isLight ? 'text-blue-600' : 'text-blue-400'} w-10 h-10`} />,
      description: "Data visualization, real-time analytics & insights"
    },
    {
      name: "Cybersecurity",
      icon: <FaShieldAlt className={`${isLight ? 'text-blue-600' : 'text-blue-400'} w-10 h-10`} />,
      description: "Penetration testing, security audits & compliance"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { 
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className={`py-16 ${isLight ? 'bg-gray-50' : 'bg-gray-900'}`}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className={`text-3xl font-bold mb-4 ${isLight ? 'text-gray-900' : 'text-white'}`}>
            Our Service Categories
          </h2>
          <p className={`text-lg max-w-3xl mx-auto ${isLight ? 'text-gray-600' : 'text-gray-300'}`}>
            We offer a comprehensive range of technology solutions to help your business innovate and grow
          </p>
        </div>
        
        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {categories.map((category, index) => (
            <motion.div
              key={index}
              className={`${
                isLight 
                  ? 'bg-white shadow-md hover:shadow-lg' 
                  : 'bg-gray-800 shadow-md hover:shadow-lg'
              } rounded-lg p-6 transition-shadow duration-300`}
              variants={itemVariants}
              whileHover={{ y: -5 }}
            >
              <div className="flex flex-col items-center text-center">
                <div className={`${isLight ? 'bg-blue-50' : 'bg-blue-900/30'} p-4 rounded-full mb-4`}>
                  {category.icon}
                </div>
                <h3 className={`text-xl font-semibold mb-2 ${isLight ? 'text-gray-900' : 'text-white'}`}>
                  {category.name}
                </h3>
                <p className={`${isLight ? 'text-gray-600' : 'text-gray-300'}`}>
                  {category.description}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ServiceCategories; 